import { lazy } from "react";
//  project import
import Loadable from "components/Loadable";
import MainLayout from "layout/MainLayout";
import NotFound from "pages/notfound/notFound";
import ErrorMesssage from "pages/notfound/ErrorMesssage";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { AI_getUserData } from "APIs/user";
import { useInstance } from "easy-redux-http-call";
import { useAuthenticate } from "utils/CustomHook";
import Loader from "components/Loader";
import AssetTabs from "pages/Assets/AssetTabs";
import Incident from "pages/Emplyoee/Incident/Incident";

const PartMenu = Loadable(lazy(() => import("pages/PartyMenu/PartyMenu")));
const Credential = Loadable(lazy(() => import("pages/Credential/Credential")));
const FeedBack = Loadable(lazy(() => import("pages/Feedback/ShowFeedbacks")));
const Assets = Loadable(lazy(() => import("pages/Assets/Assets")));
const Brand = Loadable(lazy(() => import("pages/Brand/Brand")));
const Item = Loadable(lazy(() => import("pages/Item/Item")));
const Supplier = Loadable(lazy(() => import("pages/Supplier/Supplier")));
const DashboardDefault = Loadable(lazy(() => import("pages/dashboard")));
const DepartmentDetails = Loadable(
  lazy(() => import("pages/Department/Department"))
);
const EmployeeDetailsTab = Loadable(
  lazy(() => import("pages/Emplyoee/EmplyoeeDetails/EmplyoeeDetails"))
);
const Role = Loadable(lazy(() => import("pages/Role/Role")));
const BankDetails = Loadable(
  lazy(() => import("pages/Emplyoee/Bankdetails/Bankdetails"))
);
const EmployeeListTab = Loadable(
  lazy(() => import("pages/Emplyoee/EmplyoeeTab/EmployeeListTab"))
);
const AddEmplyoee = Loadable(lazy(() => import("pages/Emplyoee/AddEmplyoee")));
const Project = Loadable(lazy(() => import("pages/Project/Project")));

const ProjectTaskTabs = Loadable(
  lazy(() => import("pages/Project_tasks/ProjectTaskTabs"))
);
const Document = Loadable(
  lazy(() => import("pages/Emplyoee/Document/Document"))
);
const Work = Loadable(lazy(() => import("pages/Emplyoee/Work/Work")));
const Education = Loadable(
  lazy(() => import("pages/Emplyoee/Education/Education"))
);
const Address = Loadable(lazy(() => import("pages/Emplyoee/Address/Address")));
const Nominee = Loadable(lazy(() => import("pages/Emplyoee/Nominee/Nominee")));
const AllNotifications = Loadable(lazy(() => import("pages/Notification/AllNotifications")));
const UserLogs = Loadable(lazy(() => import("pages/Logs/UserLogs")));

const Technology = Loadable(
  lazy(() => import("pages/Emplyoee/Technology/Technology"))
);
const Leave = Loadable(lazy(() => import("pages/Emplyoee/Leave/Leave")));
const ShowProjectEmployee = Loadable(
  lazy(() => import("pages/Project/ShowProjectEmployee"))
);
const EditEmployee = Loadable(
  lazy(() => import("pages/Emplyoee/EmployeeDetail/EditEmployee"))
);
const Attendance = Loadable(
  lazy(() => import("pages/Emplyoee/Attendance/Attendance"))
);
const Holidays = Loadable(
  lazy(() => import("pages/Settings/Holidays/Holidays"))
);
const Announcements = Loadable(
  lazy(() => import("pages/Settings/Announcements/Announcements"))
);
const LeaveBalance = Loadable(
  lazy(() => import("pages/Settings/LeaveBalance/LeaveBalance"))
);
const ExcelLeaveBalance = Loadable(
  lazy(() => import("pages/Settings/ExcelLeaveBalance/ExcelLeaveBalance"))
);
const UploadExcelLeave = Loadable(
  lazy(() => import("pages/Settings/ExcelLeaveBalance/UploadExcelLeave"))
);
const ExcelLeaveDiscrepancies = Loadable(
  lazy(() => import("pages/Settings/ExcelLeaveBalance/Discrepancies"))
);
const BalanceLeave = Loadable(
  lazy(() => import("pages/Settings/LeaveBalance/Balance/BalanceLeave"))
);
const GeneralAttendance = Loadable(
  lazy(() => import("pages/Emplyoee/Attendance/GeneralAttendance"))
);
const EmployeeWithProjectView = Loadable(
  lazy(() => import("pages/Emplyoee/EmployeeDetail/EmployeeWithProjectView"))
);
const Settings = Loadable(lazy(() => import("pages/Settings/Setting")));
const Interview = Loadable(lazy(() => import("pages/Interview/InterviewTabs")));
const HandoverDashboard = Loadable(lazy(() => import("pages/dashboard/HandoverDashboard")));
const AdminHandoverDashboard = Loadable(lazy(() => import("pages/dashboard/AdminHandoverDashboard")));
const NoticePeriodHandover = Loadable(lazy(() => import("pages/NoticePeriodHandover/NoticePeriodHandover")));
const LeaveRequestDetails = Loadable(
  lazy(() => import("pages/Emplyoee/Leave/LeaveRequestDetails"))
);
const TimeLogViewer = Loadable(
  lazy(() => import("pages/TimeLogViewer/TimeLogViewer"))
);
const LeaveCalendar = Loadable(
  lazy(() => import("pages/Calendar/LeaveCalendar"))
);
const LiveAttendance = Loadable(
  lazy(() => import("pages/Emplyoee/Attendance/LiveAttendance"))
);
const MissedPunchHistory = Loadable(
  lazy(() => import("pages/MissedPunchAlert/MissedPunchHistory"))
);
const PunchAnalysis = Loadable(
  lazy(() => import("pages/Emplyoee/Attendance/PunchAnalysis"))
);

const token = localStorage.getItem("token");

const ProtectedRoute = ({ component }) => {
  const temp = useSelector((state) => state.loginReducer.addLoginData);
  const userData = useInstance(AI_getUserData);
  const is_form_submit = userData?.data?.user?.is_submit;
  let isAuthenticated = temp?.data?.token;
  return isAuthenticated || token ? (
    is_form_submit && is_form_submit !== undefined ? (
      component
    ) : !userData?.data ? (
      <Loader />
    ) : (
      <Navigate to="/form" replace />
    )
  ) : !userData ? (
    <Loader />
  ) : (
    <Navigate to="/login" replace />
  );
};
const PrivateRoute = ({ component }) => {
  const temp = useSelector((state) => state.loginReducer.addLoginData);
  const temp1 = useSelector((state) => state.loginReducer);
  let isAuthenticated = temp?.data?.token;
  const userData = useInstance(AI_getUserData);

  const routing = useAuthenticate();
  return isAuthenticated || token ? (
    routing || routing === undefined ? (
      component
    ) : !userData?.data ? (
      <Loader />
    ) : (
      <Navigate to="/" />
    )
  ) : (
    <Navigate to="/login" replace />
  );
};

// ==============================|| ALL-PAGE ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "/",
      element: <ProtectedRoute component={<DashboardDefault />} />,
    },
    {
      path: "leave",
      element: <PrivateRoute component={<Leave />} />,
    },
    {
      path: "departments",
      element: <PrivateRoute component={<DepartmentDetails />} />,
    },
    {
      path: "roles",
      element: <PrivateRoute component={<Role />} />,
    },
    {
      path: "bank-details",
      element: <PrivateRoute component={<BankDetails />} />,
    },
    {
      path: "emplyoee",
      element: <PrivateRoute component={<EmployeeListTab />} />,
    },
    {
      path: "emplyoee/add",
      element: <PrivateRoute component={<AddEmplyoee />} />,
    },
    {
      path: "employee/:employeeid/details",
      element: <PrivateRoute component={<EmployeeDetailsTab />} />,
    },
    {
      path: "project",
      element: <PrivateRoute component={<Project />} />,
    },
    {
      path: "projects/:project_id/detail/*",
      element: <PrivateRoute component={<ProjectTaskTabs />} />,
    },
    {
      path: "document",
      element: <PrivateRoute component={<Document />} />,
    },
    {
      path: "work",
      element: <PrivateRoute component={<Work />} />,
    },
    {
      path: "education",
      element: <PrivateRoute component={<Education />} />,
    },
    {
      path: "address",
      element: <PrivateRoute component={<Address />} />,
    },
    {
      path: "nominee",
      element: <PrivateRoute component={<Nominee />} />,
    },
    {
      path: "all-notifications",
      element: <PrivateRoute component={<AllNotifications />} />,
    },
    {
      path: "user-logs",
      element: <PrivateRoute component={<UserLogs />} />,
    },
    {
      path: "technologies",
      element: <PrivateRoute component={<Technology />} />,
    },
    {
      path: "personal-details",
      element: <PrivateRoute component={<EditEmployee />} />,
    },
    {
      path: "projects",
      element: <PrivateRoute component={<ShowProjectEmployee />} />,
    },
    {
      path: "supplier",
      element: <PrivateRoute component={<Supplier />} />,
    },
    {
      path: "brand",
      element: <PrivateRoute component={<Brand />} />,
    },
    {
      path: "items",
      element: <PrivateRoute component={<Item />} />,
    },
    {
      path: "assets",
      element: <PrivateRoute component={<AssetTabs />} />,
    },
    {
      path: "attendance",
      element: <PrivateRoute component={<Attendance />} />,
    },
    {
      path: "general-attendance",
      element: <PrivateRoute component={<GeneralAttendance />} />,
    },
    {
      path: "holidays",
      element: <PrivateRoute component={<Holidays />} />,
    },
    {
      path: "announcements",
      element: <PrivateRoute component={<Announcements />} />,
    },
    {
      path: "leave-balance",
      element: <PrivateRoute component={<LeaveBalance />} />,
    },
    {
      path: "leave-balance",
      element: <PrivateRoute component={<LeaveBalance />} />,
    },
    {
      path: "balanceleave",
      element: <PrivateRoute component={<BalanceLeave />} />,
    },
    {
      path: "excel-leave-balance",
      element: <PrivateRoute component={<ExcelLeaveBalance />} />,
    },
    {
      path: "excel-leave-upload",
      element: <PrivateRoute component={<UploadExcelLeave />} />,
    },
    {
      path: "excel-leave-discrepancies",
      element: <PrivateRoute component={<ExcelLeaveDiscrepancies />} />,
    },
    {
      path: "technical-employee",
      element: <PrivateRoute component={<EmployeeWithProjectView />} />,
    },
    {
      path: "party",
      element: <PrivateRoute component={<PartMenu />} />,
    },
    {
      path: "feedback",
      element: <PrivateRoute component={<FeedBack />} />,
    },
    {
      path: "setting",
      element: <PrivateRoute component={<Settings />} />,
    },
    {
      path: "interview",
      element: <PrivateRoute component={<Interview />} />,
    },
    {
      path: "incident",
      element: <PrivateRoute component={<Incident />} />,
    },
    {
      path: "get-all-incident",
      element: <PrivateRoute component={<Incident />} />,
    },
    {
      path: "handover-dashboard",
      element: <PrivateRoute component={<HandoverDashboard />} />,
    },
    {
      path: "admin_handover_dashboard",
      element: <PrivateRoute component={<AdminHandoverDashboard />} />,
    },
    {
      path: "notice-period-handover",
      element: <PrivateRoute component={<NoticePeriodHandover />} />,
    },
    {
      path: "leave-request-details",
      element: <PrivateRoute component={<LeaveRequestDetails />} />,
    },
    {
      path: "credential",
      element: <PrivateRoute component={<Credential />} />,
    },
    {
      path: "time-log-viewer",
      element: <PrivateRoute component={<TimeLogViewer />} />,
    },
    {
      path: "leave-calendar",
      element: <PrivateRoute component={<LeaveCalendar />} />,
    },
    {
      path: "live-attendance",
      element: <PrivateRoute component={<LiveAttendance />} />,
    },
    {
      path: "missed-punch-history",
      element: <PrivateRoute component={<MissedPunchHistory />} />,
    },
    {
      path: "punch-analysis",
      element: <PrivateRoute component={<PunchAnalysis />} />,
    },
    {
      path: "/error/:errorName",
      element: <ProtectedRoute component={<ErrorMesssage />} />,
    },
    {
      path: "*",
      element: <ProtectedRoute component={<NotFound />} />,
    },
  ],
};

export default MainRoutes;
